import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import FontKeys from '../FontKeys';
import gameData from '../gameData';
import SoundAssetKeys from '../SoundAssetKeys';
import UIAssetKeys from '../UIAssetKeys';

export default class DroppingMarble extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene, maxValue) {
    super(scene);

    this.speed = gameData.MARBLE_SPEED;

    this.numValue = Phaser.Math.Between(1,maxValue);

    this.marble = ABCyaPhaser.Images.addImage(0,0,`md_assets/SmallMarble${Phaser.Math.Between(1,9)}`,this).setOrigin(0);

    this.label = ABCyaPhaser.Text.addText(0,0, 16, 0xffffff, FontKeys._BPreplay_Bold,this.numValue.toString(), this, true).setOrigin(0.5, 0);
    this.label.x = this.marble.width / 2;
    this.label.y = this.marble.height / 2 - this.label.height / 2;

    this.hasBeenSetup = false;
  }

  setupForEquation () {
    if (this.hasBeenSetup) return;
    this.hasBeenSetup = true;
    const bounds = this.getBounds();
    this.list.forEach((child) => {
      // eslint-disable-next-line no-param-reassign
      child.x -= bounds.width / 2;
      // eslint-disable-next-line no-param-reassign
      child.y -= bounds.height / 2;
    });
  }

  pulse () {
    ABCyaPhaser.Tweens.addTween(this, 400, { scale: 1.3 }, Phaser.Math.Easing.Linear, () => this.pulseBack());
    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._CorrectMark, this.scene);
  }

  pulseBack () {
    ABCyaPhaser.Tweens.addTween(this, 350, { scale: 1 }, Phaser.Math.Easing.Linear, () => this.donePulsing());
  }

  donePulsing () {
    this.emit('MARBLE_ADDED_ANIMATION_OVER');
  }

  tick (delta) {
    this.y += this.speed * (delta / 1000);
  }
}